import { FILTER_PATH_SEPARATOR } from 'src/utils/extractBasePath';
import { ALLOWED_SURFACE_SEGMENTS } from './constants';

const VALID_PATH_SHAPE = /^\/[^?#]+$/;
const SHOP_TAXONOMY_PATH_PREFIX = new RegExp(
  `^/shop/(?:${ALLOWED_SURFACE_SEGMENTS.join('|')})(?:/|$)`,
);

export const isValidPathShape = (path: string): boolean => VALID_PATH_SHAPE.test(path);

export const isValidShopTaxonomyPathPrefix = (path: string): boolean =>
  SHOP_TAXONOMY_PATH_PREFIX.test(path);

const stripQueryHashAndFilterPath = (path: string): string => {
  const withoutQueryOrHash = path.split('?')[0].split('#')[0];
  const separatorIndex = withoutQueryOrHash.indexOf(FILTER_PATH_SEPARATOR);

  return separatorIndex === -1 ? withoutQueryOrHash : withoutQueryOrHash.slice(0, separatorIndex);
};

/** Parent taxonomy base for a shop path, or null when the path is invalid. */
export const getParentPathWithoutFilters = (path: string): string | null => {
  if (!isValidPathShape(path) || !isValidShopTaxonomyPathPrefix(path)) {
    return null;
  }

  const basePath = stripQueryHashAndFilterPath(path);
  const segments = basePath.split('/').filter((segment) => segment.length > 0);

  if (segments.length <= 2) {
    return basePath;
  }

  return `/${segments.slice(0, -1).join('/')}`;
};
